import React from 'react';
import logoUrl from './tim_logo.png';

interface ILogo {
  height?: string;
}
export const Logo = (props: ILogo) => (
  <img src={logoUrl} alt="Tim" decoding="async" {...props} />
);
